import * as React from "react";
import type { SVGProps } from "react";
const FullDayIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0 2.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14" clipRule="evenodd" /></svg>;
export default FullDayIcon;